<template>
  <div ref="chartTwo" style="width:100%; height:100%;"></div>
</template>

<script>
import echarts from 'echarts';
export default {
  props:{
    options:{
      type:Object,
      default:()=>{}
    },
    config:{
      type:Object,
      default:()=>{}
    }
  },
  data(){
    return {
      chartLineBar:null
    }
  },
  watch:{
    options:{
      deep:true,
      handler(){
        this.initChart();
      }
    }
  },
  mounted(){
    this.initChart();
    window.addEventListener('resize',()=>{
      if(this.chartLineBar){
        this.chartLineBar.resize()
      }
    }) ;
  },
  methods: {
    async initChart() {
      this.chartLineBar = echarts.init(this.$refs['chartTwo'],'mytheme');
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          /* textStyle:{
            color:' #4e9dfd'
          }, */
          top:10,
          itemHeight:8,
        },
        grid:{
          containLabel:true,
          left:'3%',
          top:'18%',
          right:'3%',
          bottom:'10%'
        },
        xAxis: [
          {
            type: "category",
            axisLine:{
              /* lineStyle:{
                color:'#0f2652'
              } */
            },
            axisLabel:{
              // color:'#0f9cf0',
              rotate:45,
              showMaxLabel:true,
              /* interval:(i,name)=>{
                let num = Math.ceil(this.options.x.length/10)
                return i%num===10;
                
              } */
            },
            splitLine:{
              /* lineStyle:{
                color:'#40559f'
              } */
            },
            axisTick:{
              show:true
            },
            data: this.options.x,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.config.yName[0].unit,
             scale:true,
            /* nameTextStyle:{
              color:'#4e9dfd'
            }, */
            splitLine:{
              show:true,
              /* lineStyle:{
                color:'#40559f'
              } */
            },
            axisLabel:{
              // color:'#0f9cf0',
            },
            axisTick:{
              show:false
            },
            axisLine:{
              /* lineStyle:{
                color:'#0f2652'
              } */
            },
          },
          {
            type: "value",
            name:this.config.yName[1].unit,
            /* nameTextStyle:{
              color:'#4e9dfd'
            }, */
            splitLine:{
              show:false,
              /* lineStyle:{
                color:'#40559f'
              } */
            },
            axisLabel:{
              // color:'#0f9cf0',
            },
            axisTick:{
              show:false
            },
            axisLine:{
              /* lineStyle:{
                color:'#0f2652'
              } */
            },
          },
        ],
        series: this.options.series,
      };

      this.chartLineBar.setOption(option)
    },
  },
  beforeDestroy() {
    if (!this.chartLineBar) {
      return;
    }
    this.chartLineBar.dispose();
    this.chartLineBar = null;
  },
};
</script>
